const replaceAll = (string: string, pattern: string, replacement: string) => {
  return string.split(pattern).join(replacement);
};

export default replaceAll;
